// Base mobules
export { default as Load } from './modules/Load';
export { default as Scroll } from './modules/Scroll';
export { default as ClassToggle } from './modules/ClassToggle';
export { default as FormVend } from './modules/FormVend';
// export { default as Navs } from './modules/Navs';
// export { default as NavAnchors } from './modules/NavAnchors';
// export { default as Modal } from './modules/Modal';
// export { default as Accordion } from './modules/Accordion';

// Accessibility Navigation modules
export { default as Accessibility } from './modules/Accessibility';
export { default as AccessibilityNav } from './modules/AccessibilityNav';
export { default as SetFocus } from './modules/SetFocus';

// Addons modules
// export { default as Tabs } from './modules/Tabs';
// export { default as Figcaption } from './modules/Figcaption';
// export { default as MouseCursor } from './modules/MouseCursor';
// export { default as BFSlider } from './modules/BFSlider';
// export { default as Slider } from './modules/Slider';
// export { default as FileLabel } from './modules/FileLabel';
// export { default as FormValidation } from './modules/FormValidation';